import BecomingCreatorModalComponent from "./BecomingCreatorModalComponent";

export default BecomingCreatorModalComponent;
